import {
  Box,
  Card,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import WDBox from "../../../../MaterialComponents/WDBox";
import React, { useEffect, useState } from "react";
import ServiceTicket from "./panles/ServiceTicket";
import AppService from "../../../../Configurations/Appservice";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  dismissLoader,
  showLoader,
  updateScreenTitle,
} from "../../../../LayoutContainers/AppLayout/redux/AppSlice";
import uuid from "react-uuid";
import { APP_CONSTANTS } from "../../../../Configurations/AppConstants";

const PartnerDashboard = () => {
  const [pendingTickets, setPendingTickets] = useState([]);
  const [organisations, setOrganisations] = useState([]);
  const [organisation, setOrganisation] = useState("*");

  const location = useLocation();
  const navigate = useNavigate();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(updateScreenTitle("Partner Dashboard"));
    return () => dispatch(updateScreenTitle(""));
  }, []);

  useEffect(() => {
    dispatch(showLoader());
    const params = { orgId: organisation === "*" ? null : organisation };
    AppService.get("v1/dashboard/admin/partnerDash", { params })
      .then((response) => {
        setPendingTickets(response.pendingCustomerTickets || []);
      })
      .catch((error) => {
        alert("error");
      })
      .finally(() => {
        dispatch(dismissLoader());
      });
  }, [organisation]);

  useEffect(() => {
    const params = { type: "PARTNER" };
    AppService.get("v1/organisation/keyValues", { params })
      .then((response) => {
        setOrganisations(response);
      })
      .catch((error) => {
        alert("error");
      })
      .finally(() => {});
  }, []);

  const _navigateToPendingTickets = (ticket) => {
    // navigate("/ADM-partner/pending-tickets", {
    //   state: {
    //     ticket,
    //   },
    // });
    navigate("/ADM-Ticket/pending-tickets", {
      state: {
        partnerOrganisation: organisation === "*" ? null : organisation,
        screenType: APP_CONSTANTS.ADMIN_DASH,
        status: "TAKEN",
        serviceId: ticket.serviceId,
      },
    });
  };

  const EmptyTicketInfo = () => {
    return (
      <Box m={2}>
        <Card sx={{ p: 2 }}>
          <Typography fontSize={14}>No Tickets Pending</Typography>
        </Card>
      </Box>
    );
  };

  const _renderPendingTickets = (ticket) => {
    return (
      <Grid item xs={12} sm={3} key={uuid()}>
        <ServiceTicket ticket={ticket} onClick={() => _navigateToPendingTickets(ticket)} />
      </Grid>
    );
  };

  return (
    <Box
      sx={{
        display: "flex",
        flex: 1,
        flexDirection: "column",
        overflow: "auto",
      }}
    >
      <Grid container>
        <Grid item xs={6}>
          <Card>
            <Box p={2}>
              <FormControl sx={{ width: "100%" }}>
                <InputLabel id="demo-simple-select-label">Customer Organisation</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={organisation}
                  label="Customer Organisation"
                  onChange={(event) => setOrganisation(event.target.value)}
                >
                  <MenuItem value="*">All</MenuItem>
                  {organisations &&
                    organisations.map(({ id, name }) => <MenuItem value={id}>{name}</MenuItem>)}
                </Select>
              </FormControl>
            </Box>
          </Card>
        </Grid>
      </Grid>
      <Box my={3}>
        <Grid container spacing={1.5}>
          {pendingTickets && pendingTickets.map(_renderPendingTickets)}
          {!pendingTickets.length && <EmptyTicketInfo />}
        </Grid>
      </Box>
    </Box>
    // <WDBox>
    //   <WDBox mb={3}>
    //     <Box my={1}>
    //       <Typography variant="subtitle2">Pending Tickets</Typography>
    //     </Box>
    //     <Grid container spacing={1.5}>
    //       {pendingTickets.map(_renderPendingTickets)}
    //     </Grid>
    //   </WDBox>
    // </WDBox>
  );
};

export default PartnerDashboard;
